import { useState } from "react";
import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import AiInvoiceBanner from "./../../assets/images/banner/fo.png";
import Architecture from "./../../assets/images/banner/Architecture.png";
// import Brochures from "./../../assets/images/WA_fds.png";
import { Link } from "react-router-dom";

const resultsData = [
  { metric: "Order response time", before: "Manual replies", after: "Instant" },
  { metric: "Orders handled", before: "Limited", after: "300% increase" },
  {
    metric: "Missed orders",
    before: "Frequent",
    after: "Reduced significantly",
  },
  {
    metric: "Order accuracy",
    before: "Manual errors",
    after: "Improved accuracy",
  },
  { metric: "Processing time", before: "Slow", after: "60% faster" },
  { metric: "Hours saved monthly", before: "0", after: "60+ hours" },
];

const featureCards = [
  {
    icon: "bi bi-mic-fill",
    title: "Voice Note Ordering",
    desc: "Customers can place food orders through WhatsApp voice notes, making ordering faster and easier.",
  },
  {
    icon: "bi bi-image-fill",
    title: "Image-Based Order Support",
    desc: "The system can read menu screenshots, payment screenshots, and food-related images for smoother order handling.",
  },
  {
    icon: "bi bi-translate",
    title: "Multilingual Ordering",
    desc: "Supports English, Tamil, Malay, Mandarin, and mixed-language ordering for real customer conversations.",
  },
  {
    icon: "bi bi-chat-dots-fill",
    title: "Smart Order Understanding",
    desc: "Understands item names, quantities, customizations, and customer intent without relying only on fixed button flows.",
  },
  {
    icon: "bi bi-check2-circle",
    title: "Order Confirmation & Follow-Up",
    desc: "Automatically confirms orders, handles follow-ups, and reduces missed or incomplete food orders.",
  },
  {
    icon: "bi bi-shop",
    title: "Built for F&B Workflows",
    desc: "Suitable for restaurants, cafes, takeaway counters, catering services, and other food businesses.",
  },
];

const faqs = [
  {
    q: "How is this different from WATI or SleekFlow?",
    a: "WATI and SleekFlow are SaaS platforms with template chatbots. Voltade's AI is custom-trained on your business — it handles free-form conversations, voice notes, images, and code-switching. Plus we integrate with local systems like Plato and WESS that global tools don't support.",
  },
  {
    q: "Do I need to replace my existing CRM?",
    a: "No. Our AI agent connects to your existing CRM (HubSpot, Odoo, etc.) via API. Or you can use our built-in CRM — full pipeline, contacts, orders, and broadcasts included.",
  },
  {
    q: "How long does deployment take?",
    a: "Our CRM deploys in days. Custom AI agents take weeks, not months — including conversation mapping, training, integration, and testing. We'll give you a clear timeline during scoping.",
  },
  {
    q: "What languages does it support?",
    a: "English, Mandarin Malay, and Tamil with native code-switching support. The AI understands when customers switch languages mid-sentence — no separate language flows needed.",
  },

  {
    q: "Can it reduce manual order-taking effort?",
    a: "Yes. It automates order capture, confirmation, and follow-up, helping staff save time and reduce mistakes.",
  },
];

const Wa_Food_Ord = () => {
  pageTitle("WhatsApp Food Ordering");
const handleWhatsAppClick = () => {
  const phoneNumber = "6590059743"; // WhatsApp number (no '+' or spaces)
  const message = "Hello! I would like to know more about your services.";
  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <>
      <HeaderOne />

      <div
        className="ai-overlay-wrapper-solutions"
        style={{ backgroundImage: `url(${AiInvoiceBanner})` }}
      >
        <div className="ai-overlay">
          <div className="ai-overlay-center-project-text-solutions">
            <h2 className="ai-overlay-project">
              AI-Powered <br /> WhatsApp Food Ordering
            </h2>
          </div>
          <div className="siw-hero-price-box-sol">
            <h3>From SGD 100/month</h3>
            <button
              onClick={handleWhatsAppClick}
              className="theme-btn theme-btn-one siw-hero-small-btn"
            >
              Start a Free Trial
            </button>
            
          </div>
        </div>
      </div>

      <section className="py-3 py-md-4">
        <div className="container">
          {/* <h3 className="siw-project-heading">
            One voice note is all it takes, automate your food orders instantly
            through WhatsApp.
          </h3> */}

          <div className="row g-4 align-items-stretch">
            <div className="col-lg-7 d-flex">
              <div className="food-grey-box w-100">
                <h3 className="siw-project-heading pb-1">
                  Built for real-time food ordering conversations
                </h3>
                <p className="mb-0 siw-rpa-desc">
                  Most food ordering chatbots fail when customers order
                  naturally. People send short texts, mixed item names,
                  quantities, and voice notes. Some customers also share menu
                  screenshots or switch languages mid-message. Our WhatsApp AI
                  is built to understand these real-world ordering patterns. It
                  helps capture orders more accurately with less back-and-forth.
                </p>
                <p className="siw-rpa-desc">
                  It works based on your actual menu and business flow. The
                  system recognizes your item names, aliases, quantities, and
                  pricing. It can process text, audio, and image-based orders
                  more smoothly. This creates a faster and easier experience for
                  your customers. It also reduces manual effort and improves
                  order handling for your team.
                </p>
              </div>
            </div>

            <div className="col-lg-5 d-flex">
              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/wmpuRPpPTP4?si=rdtO9M1k_lEev4RL"
                  title="WhatsApp Food Ordering Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-3  pt-md-0 pb-md-5 wafod-features-section">
        <div className="container">
          <h3 className="wafod-section-heading">Architecture</h3>
          <img
            src={Architecture}
            alt="Architecture"
            className="img-fluid mb-4"
            height="200"
          />
          <div className="mb-5">
            <h3 className="wafod-section-heading">Key Features</h3>
          </div>

          <div className="row g-4">
            {featureCards.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="food-feature-card wafod-feature-card h-100">
                  <div className="food-feature-icon wafod-feature-icon">
                    <i className={item.icon}></i>
                  </div>
                  <h5 className="wafod-card-title">{item.title}</h5>
                  <p className="mb-0 wafod-card-text">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-3 py-md-5 wafod-results-section">
        <div className="container">
          <div className="mb-4">
            <h3 className="wafod-section-heading-light pb-1">
              Business Impact
            </h3>
          </div>

          <div className="siw-subscription-table-wrap">
            <table className="siw-subscription-table">
              <thead>
                <tr>
                  <th>Metric</th>
                  <th>Before</th>
                  <th>After</th>
                </tr>
              </thead>

              <tbody>
                {resultsData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.metric}</td>
                    <td>{row.before}</td>
                    <td>{row.after}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* <section className="py-3 py-md-4 wafod-industry-section">
        <div className="container text-center">
          <h3 className="wafod-section-heading-light">Industry Focus</h3>
          <div className="mt-4 d-inline-block px-4 py-3 shadow-sm rounded wafod-industry-card">
            <h5 className="mb-0 wafod-card-title wafod-section-heading-light">
              F &amp; B
            </h5>
          </div>
        </div>
      </section> */}

      <section className="pt-3 pb-2 py-md-4 wafod-faq-section">
        <div className="container">
          <div className=" mb-5">
            <h3 className="wafod-section-heading">Common Questions</h3>
          </div>

          <div className="accordion wafod-accordion">
            {faqs.map((item, index) => (
              <div
                className="accordion-item food-accordion-item wafod-accordion-item mb-3"
                key={index}
              >
                <h2 className="accordion-header wafod-accordion-header">
                  <button
                    type="button"
                    className={`accordion-button food-accordion-btn wafod-accordion-btn ${
                      openIndex !== index ? "collapsed" : ""
                    }`}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                  >
                    {item.q}
                  </button>
                </h2>

                <div
                  className={`accordion-collapse collapse ${
                    openIndex === index ? "show" : ""
                  }`}
                >
                  <div className="accordion-body wafod-accordion-body">
                    {item.a}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <section className="pt-0 pb-4 pb-md-5">
        <div className="container">
          <div className="mb-5">
            <h3 className="siw-project-heading">Download Brochure</h3>
          </div>

          <div className="row g-4 align-items-left">
            <div className="col-md-6 d-flex flex">
              <div className="food-grey-box w-100 d-flex flex-column ">
                <img
                  src={Brochures}
                  alt="Food Ordering Brochure"
                  className="food-brochure-preview img-fluid mx-auto my-2"
                  onClick={() => setShowBrochureModal(true)}
                />

                <a
                  href={Brochures}
                  download="WA_fds.png"
                  className="siw-rpa-btn mt-2 text-center w-50 mx-auto"
                >
                  Download Brochure
                </a>
              </div>
            </div>

            {showBrochureModal && (
              <div
                className="wafod-brochure-modal"
                onClick={() => setShowBrochureModal(false)}
              >
                <div
                  className="wafod-brochure-modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    type="button"
                    className="wafod-brochure-close"
                    onClick={() => setShowBrochureModal(false)}
                  >
                    &times;
                  </button>

                  <img
                    src={Brochures}
                    alt="Food Ordering Brochure Preview"
                    className="wafod-brochure-modal-img"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </section> */}

      <FooterOne />
    </>
  );
};

export default Wa_Food_Ord;
